import type { AdminTransaction } from "../types";

export type TransactionAttention = "failure" | "stale" | null;

export const TRANSACTION_FAILURE_STATES = ["failed", "rejected", "reversed", "error"] as const;
export const TRANSACTION_STALE_STATES = ["pending", "processing", "created"] as const;

export function transactionAttention(status: string, updatedAt: string | null, now = Date.now()): TransactionAttention {
  const state = status.trim().toLowerCase();
  if ((TRANSACTION_FAILURE_STATES as readonly string[]).includes(state)) return "failure";
  if (!(TRANSACTION_STALE_STATES as readonly string[]).includes(state) || !updatedAt) return null;
  const parsed = Date.parse(updatedAt);
  return Number.isFinite(parsed) && now - parsed >= 24 * 60 * 60 * 1000 ? "stale" : null;
}

export function transactionNeedsAttention(transaction: AdminTransaction, now = Date.now()): boolean {
  return transactionAttention(transaction.status, transaction.updatedAt, now) !== null;
}

function csvCell(value: unknown): string {
  const raw = value === null || value === undefined ? "" : String(value);
  const text = /^[=+\-@\t\r]/.test(raw) ? `'${raw}` : raw;
  return `"${text.replaceAll('"', '""')}"`;
}

export function transactionsCsv(transactions: AdminTransaction[]): string {
  const rows = transactions.map((transaction) => [
    transaction.transferId, transaction.guid, transaction.customerGuid, transaction.customerName,
    transaction.email, transaction.displayType, transaction.transferType, transaction.movementType,
    transaction.side, transaction.amountCents, transaction.estimatedAmountCents, transaction.feeCents,
    transaction.asset, transaction.status, transaction.state, transaction.paymentRail,
    transaction.quoteGuid, transaction.externalAccountGuid, transaction.sourceAccountGuid,
    transaction.destinationAccountGuid, transaction.parentTransferId, transaction.createdAt, transaction.updatedAt
  ]);
  return [
    ["transfer_id", "guid", "customer_guid", "customer_name", "email", "display_type", "transfer_type", "movement_type", "side", "amount_cents", "estimated_amount_cents", "fee_cents", "asset", "status", "state", "payment_rail", "quote_guid", "external_account_guid", "source_account_guid", "destination_account_guid", "parent_transfer_id", "created_at", "updated_at"],
    ...rows
  ].map((row) => row.map(csvCell).join(",")).join("\r\n");
}
